// extracted by mini-css-extract-plugin
export default {"reviewButtonContainer":"ReviewContentItemContentReviewText-module-reviewButtonContainer-kTtuM","spinnerContainer":"ReviewContentItemContentReviewText-module-spinnerContainer-NpNA7"};